import { EventBus } from "../../../plugins/eventBus";

const commonMethods = {
  data() {
    return {
      fields: { text: 'showName', value: 'value' },
      styles: {
        width: '400px',
        height: '600px',
        visible: false,
        model: true,
        zIndex: 1001
      },
      optionsUserType: [
        {
          showName: this.$t('MCS.all'),
          value: 0
        },
        {
          showName: this.$t('MCS.user'),
          value: 1
        },
        // {
        //   showName: this.$t('MCS.admin'),
        //   value: 2
        // },
        {
          showName: this.$t('MCS.dc'),
          value: 3
        },
        {
          showName: this.$t('MCS.mobile'),
          value: 4
        }
      ],
      optionsUserPrivilege: [
        {
          showName: this.$t('MCS.ordinaryUser'),
          value: 0
        },
        {
          showName: this.$t('MCS.highUser'),
          value: 1
        },
        {
          showName: this.$t('MCS.superUser'),
          value: 2
        },
      ],
      optionsUserPriority: [
        {
          showName: '1',
          value: 1
        },
        {
          showName: '2',
          value: 2
        },
        {
          showName: '3',
          value: 3
        },
        {
          showName: '4',
          value: 4
        },
        {
          showName: '5',
          value: 5
        },
        {
          showName: '6',
          value: 6
        },
        {
          showName: '7',
          value: 7
        }
      ],
      msg: {
        // cms
        addUser: 24752,
        modUser: 24753,
        delUser: 24754,
        qryUsers: 24755,
        qryModUser: 24756,
        delGroupList: 24762,
        qryGroupList: 24763,
        addBlackList: 24764,
        delBlackList: 24766,
        qryBlackList: 24767,
        // gms
        addGroup: 25750,
        modGroup: 25751,
        delGroup: 25752,
        qryGroups: 25753,
        qryModGroup: 25754,
        addGroupMember: 25766,
        modGroupMember: 25767,
        delGroupMember: 25768,
        qryGroupMember: 25769,
        addGpsArea: 25778,
        modGpsArea: 25779,
        delGpsArea: 25780,
        qryGpsArea: 25781
      },
      regex: {
        char: '^[a-zA-Z0-9\u4e00-\u9fa5]+$',
        noMatchRegex: '^@_-@_-@_-@_-@_-@_$'
      },
      errorCode: {
        breakLine: 'subscriber.9005'
      }
    };
  },
  methods: {
    /**
     *  cms
     */
    participantTypeFormatter(field, data) {
      return ['', this.$t('MCS.user'), this.$t('MCS.admin'), this.$t('MCS.dc'), this.$t('MCS.mobile')][data.participantType];
    },

    registerStatusFormatter(field, data) {
      return [this.$t('MCS.offline'), this.$t('MCS.online')][data.registerStatus];
    },

    stunStatusFormatter(field, data) {
      return [this.$t('MCS.working'), this.$t('MCS.stun'), this.$t('MCS.kill')][data.stunStatus];
    },

    /**
     *  gms
     */
    grouptypeFormatter(field, data) {
      return [this.$t('MCS.staticGroup'), this.$t('MCS.dynamicGroup'), this.$t('MCS.areaGroup')][data.grouptype];
    },

    userPrivilegeFormatter(field, data) {
      return [this.$t('MCS.ordinaryUser'), this.$t('MCS.highUser'), this.$t('MCS.superUser')][data.user_privilege];
    },

    /**
     * common
     */

    // 拼写vo循环方法, 适用批量操作
    voCycleSpell(staticMap, dynamicMap, dynamicParamsLength) {
      const vo = [];
      for (let i = 0; i < dynamicParamsLength; i++) {
        const tempObj = {};
        staticMap.forEach((item, key) => {
          tempObj[key] = item;
        });
        dynamicMap.forEach((item, key) => {
          tempObj[key] = item[i];
        });
        vo.push(tempObj);
      }
      return vo;
    },

    utf8Length(inputStr, maxLength) {
      let totalLength = 0;
      /* 计算utf-8编码情况下的字符串长度 */
      for (let i = 0; i < inputStr.length; i++) {
        if (inputStr.charCodeAt(i) <= parseInt(0x7F)) {
          totalLength += 1;
        } else if (inputStr.charCodeAt(i) <= parseInt('0x7FF')) {
          totalLength += 2;
        } else if (inputStr.charCodeAt(i) <= parseInt('0xFFFF')) {
          totalLength += 3;
        } else if (inputStr.charCodeAt(i) <= parseInt('0x1FFFFF')) {
          totalLength += 4;
        } else if (inputStr.charCodeAt(i) <= parseInt('0x3FFFFFF')) {
          totalLength += 5;
        } else {
          totalLength += 6;
        }
      }
      return totalLength <= maxLength;
    },

    $toast(type, content = '') {
      const $this = this;
      switch (type) {
        case 'success':
          EventBus.$emit('toast', { type: 'success', content: $this.$t('Common.tips.success') } );
          break;
        case 'failure':
          if (content === '') {
            content = $this.$t('Common.tips.failure');
          }
          EventBus.$emit('toast', { type: 'error', content: content } );
          break;
        default:
          EventBus.$emit('toast', { type: type, content: content } );
      }
    },

    /**
     * 截取形如 a.b.c 的结果 返回 c
     */
    splitResult(result) {
      const arr = result.split('.');
      if (arr.length !== 3) {
        console.log('subsriber result error. ');
        return -1;
      } else if (arr.length === 3) {
        return arr[2];
      }
    }
  }
};
export default commonMethods;
